import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'

import { iconButtonTheme, IconButtonStyles } from '@vfuk/core-icon-button'
import { TextInputStyles } from '@vfuk/core-text-input'
import { AnimateStyles } from '@vfuk/core-animate'
import { respondTo, spacing } from '@vfuk/core-mixins'

import type { StyledSearchTextInputProps } from './SearchTextInput.style.types'

export const SearchWrapper = styled.div(
  (): FlattenSimpleInterpolation => css`
    display: flex;
  `,
)

export const Input = styled.span(
  (): FlattenSimpleInterpolation => css`
    ${TextInputStyles.TextInput} {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: 0;
      ${spacing('padding-left', 3)};
    }
  `,
)

export const SearchInput = styled.div(
  (): FlattenSimpleInterpolation => css`
    position: relative;
    align-items: center;
    flex-grow: 1;
  `,
)

export const InteractionIcons = styled.div(
  (): FlattenSimpleInterpolation => css`
    ${AnimateStyles.Animate} {
      display: flex;
      align-items: center;
    }

    ${spacing('padding-right', 3)};
    position: absolute;
    display: flex;
    align-items: center;
    top: 0;
    bottom: 0;
    right: 0;
  `,
)

export const SearchIcon = styled.span((props: StyledSearchTextInputProps): FlattenSimpleInterpolation => {
  const localTheme = iconButtonTheme(props.theme)
  const borderSize = props.hasState ? 4 : 2
  const mobileBorderSize = props.hasState ? 2 : 0

  return css`
    ${IconButtonStyles.IconButton} {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      height: ${mobileBorderSize + localTheme.size[props.size!].sm.buttonSize}px;

      ${respondTo.md(css`
        height: ${borderSize + localTheme.size[props.size!].md.buttonSize}px;
      `)}
    }
  `
})
